module.exports = __webpack_public_path__ + "static/media/BFH.b881778f.svg";